import { Turno } from "src/gql/schema"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

export type TurnoNocturnoCheck = Pick<Turno, "nombre" | "hora_entrada" | "hora_salida">

// Determina si el turno Nocturno ya terminó (con 30 min de margen antes de su hora de salida)
export const useCheckNocturnoEnd = () => {
    const { nowHotel } = useFormatDate()

    const checkNocturnoEnd = (turnos?: TurnoNocturnoCheck[]): boolean | undefined => {
        if (!Array.isArray(turnos)) {
            return undefined
        }

        const currentTime = nowHotel
        const nocturnoTurn = turnos.find((turno) => turno.nombre === "Nocturno")

        if (!nocturnoTurn) {
            return undefined
        }

        const horaEntrada = new Date(currentTime)
        const [horaEntradaHours, horaEntradaMinutes, horaEntradaSeconds] = nocturnoTurn.hora_entrada.split(":")
        const entradaSeconds = horaEntradaSeconds.split("+")
        horaEntrada.setUTCHours(Number(horaEntradaHours), Number(horaEntradaMinutes), Number(entradaSeconds[0]))

        const horaSalida = new Date(currentTime)
        const [horaSalidaHours, horaSalidaMinutes, horaSalidaSeconds] = nocturnoTurn.hora_salida.split(":")
        const salidaSeconds = horaSalidaSeconds.split("+")
        horaSalida.setUTCHours(Number(horaSalidaHours), Number(horaSalidaMinutes), Number(salidaSeconds[0]))

        // Restar 30 minutos a la hora de salida
        const adjustedHoraSalida = new Date(horaSalida.getTime() - 30 * 60000)

        // Verificar si la hora actual está dentro del turno nocturno
        if (currentTime >= horaEntrada && currentTime <= adjustedHoraSalida) {
            return false
        }
        return true
    }

    return { checkNocturnoEnd }
}
